import { Directive, Input, AfterViewInit, SimpleChanges, OnChanges, Output, EventEmitter, OnDestroy } from '@angular/core';
import { ImageBlock } from 'src/app/shared/model/container.models';
import { each } from 'lodash';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ConfirmationModelComponent } from 'src/app/shared/components/confirmation-model/confirmation-model.component';
import { Modalconfig } from 'src/app/shared/constants';
import { CommonHttpService } from 'src/app/shared/services/common-http/common-http.service';
declare let $: any;
declare let CKEDITOR: any;
@Directive({
    selector: '[appHotspotEditor]',
    standalone: false
})
export class HotspotEditorDirective implements AfterViewInit, OnChanges, OnDestroy {

  @Input() imgBlock: ImageBlock;
  @Input() imagepath: string;
  @Input() public imageid: number;
  @Output() onHotspotUpdateString: EventEmitter<ImageBlock> = new EventEmitter();
  hotspotIds:[];
  constructor(
      private modalService: BsModalService,
      private commonHttpService: CommonHttpService
      ) {}
  ngOnChanges(changes: SimpleChanges) {
    if (changes.imageid.previousValue && changes.imageid.previousValue !== changes.imageid.currentValue) {
      this.loadEditor();
    }
  }
  ngOnDestroy() {
    if (CKEDITOR.instances.hotform_ck_onclick_disptext) CKEDITOR.instances.hotform_ck_onclick_disptext.destroy();
    if (CKEDITOR.instances.hotform_ck_hover_disptext) CKEDITOR.instances.hotform_ck_hover_disptext.destroy();
  }
  ngAfterViewInit() {
      // to handle hotspot string
     if (this.imgBlock && this.imgBlock.hotspotHtmlString) {
        this.imgBlock.hotspotEditedHtmlString = this.handleHotspotString(this.imgBlock.hotspotEditedHtmlString);
      }
    setTimeout(() => {
      $('#hotspotConfiguration').hide();
      this.loadEditor();
    }, 100);
  }
 /**
   * To change hotspot string to make it compatible with new viewer
   * @param str hotspot string
   */
  handleHotspotString(str: string) {
   let  newStr = str.replace(/\/Content\/images\//g, 'assets/img/');
    newStr = newStr.replace(/↵/g, '');
    return newStr;
  }

  loadEditor() {
    let self = this;
    function removeAllHotSpot(){
          setTimeout(function(){
              loadImage(true);
          },500);
      }
      //==========Element Caching================//
      var $hotform_rad_gotourl = $("#hotform_rad_gotourl");
      var $hotform_rad_disptext = $("#hotform_rad_disptext");
      var $hotform_txt_gotourl = $("#hotform_txt_gotourl");
      var $hotform_ck_onclick_disptext = $("#hotform_ck_onclick_disptext");
      var $hotform_ck_hover_disptext = $("#hotform_ck_hover_disptext");
      var $deleteHotspotId = $("#deleteHotspotId");
      var $Hotspotcancel = $("#Hotspotcancel");
      var $ok = $("#ok");
      var $tab_onclick = $("#tab_onclick");
      var $tab_hover = $("#tab_hover");
      var $trigger_text = $("#trigger_text");
      var $data_content_redirect_hover=$("#data_content_redirect_hover");
      var editor_click_disptext;
      var $NewWindow=$("#new_window");
      var $SameWindow=$("#same_window");
      var $invalidMessageSpan=$("#invalidMessageSpan");
      $invalidMessageSpan.hide();
       if (!CKEDITOR.instances.hotform_ck_onclick_disptext) {
           editor_click_disptext = CKEDITOR.replace("hotform_ck_onclick_disptext");
       }
       else {
           editor_click_disptext = CKEDITOR.instances.hotform_ck_onclick_disptext;
       }

      var editor_hover_disptext;
      if (!CKEDITOR.instances.hotform_ck_hover_disptext) {
          editor_hover_disptext = CKEDITOR.replace("hotform_ck_hover_disptext");
      }
      else {
          editor_hover_disptext = CKEDITOR.instances.hotform_ck_hover_disptext;
      }
      //============ Events =======================/
      $hotform_rad_disptext.click(function () {
          var val = $(this).prop("checked");
          if (val == true)
          {
              $hotform_rad_gotourl.prop("checked", false);
              $hotform_txt_gotourl.val("");
              editor_click_disptext.setReadOnly(false);
              $hotform_txt_gotourl.prop("disabled", true);

              $NewWindow.prop("disabled", true);
              $SameWindow.prop("disabled", true);

              $trigger_text.val("click");
              $ok.prop("disabled", true);
          }
      });
      $SameWindow.click(function(){
          setTimeout(function () {
              var IsvalidUrl = CheckUrl($hotform_txt_gotourl.val());
              if (IsvalidUrl && $hotform_txt_gotourl.val().length > 0) {
                $ok.prop("disabled", false);
              }else{
                $ok.prop("disabled", true);
              }
            },100);
      })
      $NewWindow.click(function(){
        setTimeout(function () {
            var IsvalidUrl = CheckUrl($hotform_txt_gotourl.val());
            if (IsvalidUrl && $hotform_txt_gotourl.val().length > 0) {
              $ok.prop("disabled", false);
            }else{
              $ok.prop("disabled", true);
            }
          },100);
      })
      $hotform_rad_gotourl.click(function () {
          var val = $(this).prop("checked");
          if (val == true) {
              editor_click_disptext.setData("",function(){
                  editor_click_disptext.setReadOnly(true);
              });
              $hotform_rad_disptext.prop("checked", false);
              $hotform_txt_gotourl.prop("disabled", false);
              $NewWindow.prop("disabled", false);
              $SameWindow.prop("disabled", false);
              $ok.prop("disabled", true);
          }
      });


      $hotform_txt_gotourl.on("keydown keypress change blur paste", function () {
          setTimeout(function () {
              var IsvalidUrl = CheckUrl($hotform_txt_gotourl.val());
              if (IsvalidUrl && $hotform_txt_gotourl.val().length > 0) {
                  $ok.prop("disabled", false);
                  $invalidMessageSpan.hide();
                  $("#data_content").val($hotform_txt_gotourl.val());
              }
              else {
                  $ok.prop("disabled", true);
                  $invalidMessageSpan.show();
              }
          }, 10);
      });

      editor_click_disptext.on("change", function (val) {

          if (CheckCkEditorEmpty(editor_click_disptext) == false && editor_click_disptext.getData().length > 0) {
              $ok.prop("disabled", false);
              $("#data_content").val(editor_click_disptext.getData());
          }
          else {
              $ok.prop("disabled", true);
          }
      });

      editor_hover_disptext.on("change", function (val) {
          if (CheckCkEditorEmpty(editor_hover_disptext) == false && editor_hover_disptext.getData().length > 0) {
              $ok.prop("disabled", false);
              $("#data_content").val(editor_hover_disptext.getData());
          }
          else {
              $ok.prop("disabled", true);
          }
      });

      $tab_onclick.click(function () {
          $trigger_text.val("click");

          if (CheckCkEditorEmpty(editor_click_disptext) == false && editor_click_disptext.getData().length > 0) {
              $ok.prop("disabled", false);
              $("#data_content").val(editor_click_disptext.getData());
          }
          else if($hotform_txt_gotourl.val().length > 0){
              $ok.prop("disabled", false);
              if(editor_hover_disptext.getData().length > 0){
                  $trigger_text.val("hover");
              }
              $("#data_content").val($hotform_txt_gotourl.val());
          }else{
              $ok.prop("disabled", true);
          }

      });

      $tab_hover.click(function () {
          $trigger_text.val("hover");
          if (CheckCkEditorEmpty(editor_hover_disptext) == false && editor_hover_disptext.getData().length > 0) {
              $ok.prop("disabled", false);

              $("#data_content").val(editor_hover_disptext.getData());
          }
          else {
              $ok.prop("disabled", true);
          }
      });


      //============= Validations============//

      function CheckCkEditorEmpty(instance)
      {
           var html = instance.getSnapshot();
           var dom = document.createElement("DIV");
           dom.innerHTML = html;
           var plain_text = (dom.textContent || dom.innerText);
           plain_text=plain_text.replace(/(\r\n\s|\n|\r|\s)/gm, "");
           return (plain_text == "");
      }

      function CheckUrl(url) {
          return true;
      }

      function SetDefaultSettings()
      {
          //==============Default Settings =============/
          //==click
          $tab_onclick.trigger("click");
          $hotform_rad_gotourl.prop("checked", true);
          $hotform_rad_disptext.prop("checked", false);
          $hotform_txt_gotourl.prop("disabled", false);
          $hotform_ck_onclick_disptext.prop("disabled", true);
          $NewWindow.prop("checked", true);
          $SameWindow.prop("checked", false);
          $NewWindow.prop("disabled", false);
          $SameWindow.prop("disabled", false);
          editor_click_disptext.setData("",function(){
             editor_click_disptext.setReadOnly(true);
           });

          $hotform_txt_gotourl.val("");

          //===hover
          editor_hover_disptext.setData("");

      }

      $("#ok").click(function () {
          saveHotspot(null);
      });
      $("#deleteHotspotId").click(function () {

           const initialState = {
            msg: `Are you sure you would like to delete this hotspot ?`
          };
    
          const confirmationModalRef = self.modalService.show(ConfirmationModelComponent,
            Object.assign({ initialState }, { class: 'custom-modal' }, Modalconfig));
    
          confirmationModalRef.content.onclose.subscribe((toClose: boolean) => {
            confirmationModalRef.hide();
            if (toClose) {
                var a = "#" + $("#data_id").val();

                $(a).parent().remove();
                var modalElement = $("#hotspotConfiguration");
                modalElement.hide();
                resetHotSpots();
                self.imgBlock.hotspotHtmlString = generateCode();
            }
          });
      });
      function removeToolTips() {
          $(".litetooltip-wrapper").each(function () {
              $("#" + $(this).attr("id")).click();
          });
      }
      function resetHotSpots() {
          self.imgBlock.hotspotEditedHtmlString = '';
          $("#map-area").find(".selector").each(function () {
              var $this = $(this);
                self.imgBlock.hotspotEditedHtmlString += $this.prop('outerHTML').replace(/&quot;/g, '"');
          });
          self.onHotspotUpdateString.emit(self.imgBlock);
      }

      function saveHotspot(id) {
          var modalElement = $("#hotspotConfiguration");
          var a = "#" + $("#data_id").val();
          var c = $(a).clone();
          $(c).appendTo($(a).parent());
          $(a).remove();
          var d = $.now();
          var b = "hotspot_" + d;
          $(c).attr("id", b);
          $("#data_id").val(b);
          a = "#" + $("#data_id").val();
          var eleId;
          var outSideClickId;
          if ($("#" + $("#data_id").val()).data("cssconfig")) {
              outSideClickId="hotspot_" + d
              eleId = $("#" + $("#data_id").val()).data("cssconfig");
          } else {
              outSideClickId = "#" + id;
              eleId = $("#" + id).data("cssconfig");
          }

          var cssConfig = JSON.parse(unescape(eleId));
          cssConfig.trigger = $("#trigger_text").val() != "" ? $("#trigger_text").val() : "click";
          var checkforClick = $("#trigger_text").val() != "" ? $("#trigger_text").val() : "click";

          if (cssConfig.type !== "button") {
              $(a).parent().resizable({
                  alsoResize: $(a)
              });
          }
          $(a).data("trigger", $("#trigger_text").val() == "" ? "click" : $("#trigger_text").val());
          if($hotform_rad_gotourl.prop("checked") == true && $hotform_txt_gotourl.val().length > 0 && editor_hover_disptext.getData().length > 0){
              $(a).data("trigger","hover");
              cssConfig.trigger ="hover";
              $(a).find(".data-container").html(editor_hover_disptext.getData());
              $data_content_redirect_hover.val(editor_hover_disptext.getData());
          }else if($hotform_rad_gotourl.prop("checked") == true && $hotform_txt_gotourl.val().length > 0){
              $(a).data("trigger","");
              cssConfig.trigger ="";
              $(a).find(".data-container").html($("#data_content").val());
          }
          else {
              $(a).find(".data-container").html($("#data_content").val());
          }

          $(a).data("location", "bottom");
          if ($("#data_template").val() != "default") {
              $(a).data("template", $("#data_template").val())
          }
          if ($("#data_templatename").val() != "default") {
              $(a).data("templatename", $("#data_templatename").val())
          }
          $(a).data("hotspot-borderradius", cssConfig["border-radius"]);


          $(a).data("hotspot-bordercolor", cssConfig["border-radius"]);

          //==========Static Properties Start===============
          $(a).data("opacity", 1);
          $(a).data("backcolor", "#ffffff");
          $(a).data("textcolor", "#000000");
          $(a).data("textalign", "center");
          $(a).data("margin", "5");
          $(a).data("padding", "10");
          $(a).data("width", "0");
          $(a).data("delay", "0");
          $(a).data("issticky", "false");
          $(a).data("hotspot-blink", false);
          $(a).data("hotspot-bgcolor", "#ffffff");
          $(a).data("hotspot-bordercolor", "#cc0000");
          //=========Static Properties END================

          $(a).data("hot-cssconfig", cssConfig);
          $(a).css({
              background: cssConfig["background"],
              "background-image": cssConfig["background-image"],
              "border-radius": cssConfig["border-radius"]
          });
          self.imgBlock.hotspotEditedHtmlString = "";
          $("#map-area").find(".selector").each(function () {

              if ($(this).attr("id") == cssConfig.id) {

                  $(this).find(".hotspot").attr("data-trigger", cssConfig.trigger);
                  $(this).find(".hotspot").attr("data-"+$hotform_rad_gotourl.attr("id"), $hotform_rad_gotourl.prop("checked"));
                  $(this).find(".hotspot").attr("data-" + $hotform_txt_gotourl.attr("id"), $hotform_txt_gotourl.val());
                  if (($hotform_rad_gotourl.prop("checked") == true && $hotform_txt_gotourl.val().length > 0) || ($hotform_rad_gotourl.prop("checked") == true && $hotform_txt_gotourl.val().length > 0 && editor_hover_disptext.getData().length > 0)) {

                      var radioValue = $("input[name='redirectType']:checked").val();
                        if(radioValue){
                          $(this).find(".hotspot").attr("data-redirecttype",radioValue);
                        }
                      cssConfig.isredirect = {isredirect:true,value:$hotform_txt_gotourl.val()};
                      $(this).find(".hotspot").attr("data-isredirect",escape(JSON.stringify(cssConfig.isredirect)));
                  } else {
                      cssConfig.isredirect = {isredirect:false,value:""};
                      $(this).find(".hotspot").attr("data-isredirect", escape(JSON.stringify(cssConfig.isredirect)));
                  }

                  $(this).find(".hotspot").attr("data-" + $hotform_rad_disptext.attr("id"), $hotform_rad_disptext.prop("checked"));
                  $(this).find(".hotspot").attr("data-" + $hotform_ck_onclick_disptext.attr("id"), escape(editor_click_disptext.getData()));
                  $(this).find(".hotspot").attr("data-" + $hotform_ck_hover_disptext.attr("id"), escape(editor_hover_disptext.getData()));

                  $(this).find(".hotspot").attr("data-trigger", cssConfig.trigger);


              }
              self.imgBlock.hotspotEditedHtmlString += $(this).prop('outerHTML').replace(/&quot;/g, '"');
              self.onHotspotUpdateString.emit(self.imgBlock);
          });
          loadImage(false);

          //Viewer's Html
          self.imgBlock.hotspotHtmlString = generateCode();
          self.onHotspotUpdateString.emit(self.imgBlock);
          modalElement.hide();
      }

      function getDataTitle(a) {
          return $(a).find(".data-container").html()
      }

      function changeSelection(a) {
          $("#map-area").find(".selector").each(function () {
              $(this).css({
                  "border-color": "#bbbbbb",
                  background: "none"
              })
          });
          $(a).css({
              "border-color": "#111111",
              background: "rgba(255, 255, 255, 0.35)",
              height: $(a).find(".hotspot").height() + 10,
              width: $(a).find(".hotspot").width() + 10
          })
      }
      function destroyCKEDITORS() {
          if (CKEDITOR.instances.hotform_ck_onclick_disptext) CKEDITOR.instances.hotform_ck_onclick_disptext.destroy();
          if (CKEDITOR.instances.hotform_ck_hover_disptext) CKEDITOR.instances.hotform_ck_hover_disptext.destroy();
      }



      function setProperties(a, event,isOpenModal) {

          a = $(a).find(".hotspot");
          $("#data_id").val(a.attr("id"));

          $("#data_template").val(a.data("template") != null ? a.data("template") : "default");
          $("#data_templatename").val(a.data("templatename") != null ? a.data("templatename") : "default");
          $("#data_opacity").val(a.data("opacity") != null ? a.data("opacity") : 0.8);
          $("#data_backcolor").val(a.data("backcolor") != null ? a.data("backcolor") : "#000000");
          $("#data_textcolor").val(a.data("textcolor") != null ? a.data("textcolor") : "#ffffff");
          $("#data_textalign").val(a.data("textalign") != null ? a.data("textalign") : "center");
          $("#data_margin").val(a.data("margin") != null ? a.data("margin") : 5);
          $("#data_padding").val(a.data("padding") != null ? a.data("padding") : 10);
          $("#data_width").val(a.data("width") != null ? a.data("width") : 0);
          $("#data_delay").val(a.data("delay") != null ? a.data("delay") : 0);

          $("#data_issticky").val(a.data("issticky") != null ? String(a.data("issticky")) : "true");
          $("#data_h_blink").val(a.data("hotspot-blink") != null ? String(a.data("hotspot-blink")) : "true");
          $("#data_h_bgcolor").val(a.data("hotspot-bgcolor") != null ? a.data("hotspot-bgcolor") : "#cc0000");
          $("#data_h_bordercolor").val(a.data("hotspot-bordercolor") != null ? a.data("hotspot-bordercolor") : "#cc0000");
          $("#data_h_borderradius").val(a.data("hotspot-borderradius") != null ? a.data("hotspot-borderradius") : 20);
          $("#data_location").val(a.data("location") != null ? "bottom" : "bottom");

          $("#data_trigger").val(a.data("trigger") != "" ? a.data("trigger"):"click");

          $("#trigger_text").val(a.data("trigger") != "" ? a.data("trigger"):"click");

          var modalElement = $("#hotspotConfiguration");
          SetDefaultSettings();
          if (a.data("trigger") == "click" && unescape(a.data($hotform_ck_onclick_disptext.attr("id"))).length > 0) {

              $tab_onclick.trigger("click");
              $hotform_rad_disptext.prop("checked", true);

              $hotform_rad_gotourl.prop("checked", false);
              $hotform_txt_gotourl.val("");
              $hotform_txt_gotourl.prop("disabled", true);
              $NewWindow.prop("disabled", true);
              $SameWindow.prop("disabled", true);
              setTimeout(function () {
                   editor_click_disptext.setData(unescape(a.data($hotform_ck_onclick_disptext.attr("id"))),function(){
                       editor_click_disptext.setReadOnly(false);
                   });
                  $ok.prop("disabled", false);
              }, 200);
              $("#data_content").val(unescape(a.data($hotform_ck_onclick_disptext.attr("id"))));


          } else if (a.data("trigger") == "hover") {

              $tab_hover.trigger("click");
              editor_hover_disptext.setReadOnly(false);

              setTimeout(function () {
                  if (a.data($hotform_rad_gotourl.attr("id"))) {
                    if(a.data("redirecttype") == "newwindow"){
                      $NewWindow.prop("checked", true);
                      $SameWindow.prop("checked", false);
                    }else if(a.data("redirecttype") == "samewindow"){
                      $SameWindow.prop("checked", true);
                      $NewWindow.prop("checked", false);
                    }else{
                      $NewWindow.prop("checked", true);
                      $SameWindow.prop("checked", false);
                    }
                      $hotform_rad_gotourl.prop("checked", true);
                      $hotform_txt_gotourl.prop("disabled", false);
                      $hotform_txt_gotourl.val(a.data($hotform_txt_gotourl.attr("id")));
                      $hotform_rad_disptext.prop("checked", false);
                      editor_click_disptext.setData("",function(){
                          editor_click_disptext.setReadOnly(true);
                      });

                  }
                  editor_hover_disptext.setData(unescape(a.data($hotform_ck_hover_disptext.attr("id"))));
                  $ok.prop("disabled", false);
              }, 200);
              $("#data_content").val(unescape(a.data($hotform_ck_hover_disptext.attr("id"))));
          }else if (a.data($hotform_rad_gotourl.attr("id")) && a.data($hotform_txt_gotourl.attr("id")).length >0) {

              $tab_onclick.trigger("click");
              if(a.data("redirecttype") == "newwindow"){
                $NewWindow.prop("checked", true);
                $SameWindow.prop("checked", false);
              }else if(a.data("redirecttype") == "samewindow"){
                $SameWindow.prop("checked", true);
                $NewWindow.prop("checked", false);
              }else{
                $NewWindow.prop("checked", true);
                $SameWindow.prop("checked", false);
              }
              $hotform_rad_gotourl.prop("checked", true);
              $hotform_txt_gotourl.prop("disabled", false);
              $hotform_txt_gotourl.val(a.data($hotform_txt_gotourl.attr("id")));
              $hotform_rad_disptext.prop("checked", false);
              editor_click_disptext.setData("",function(){
                  editor_click_disptext.setReadOnly(true);
              });

              a.data("trigger","");
              $("#data_content").val(a.data($hotform_txt_gotourl.attr("id")));
          } else {

              $("#data_content").val("");
              SetDefaultSettings();
          }







          if(isOpenModal == true){
              modalElement.show();
              var position = event.target.getBoundingClientRect();
              var x = position.left - 35;
              var y = position.top + 2;
              modalElement.find(".modal-container").css({ 'margin-top': "0px" });
              modalElement.find(".arrow-up").css({ 'margin-top': (y + 23) + "px" });
              modalElement.find(".arrow-up").css({ 'margin-left': (x + 35) + "px" });
              modalElement.scrollTop(0);
              $invalidMessageSpan.hide();
          }


      }
      $("#Hotspotcancel").click(function () {
          $invalidMessageSpan.hide();
          var modalElement=$("#hotspotConfiguration");
          modalElement.hide();
      });

      $("#close").click(function () {
          $invalidMessageSpan.hide();
          var modalElement=$("#hotspotConfiguration");
          modalElement.hide();
      });

      function generateCode() {

          var d = $("#map-area").find("img").attr("src");
          
          if (d == null) {
              return
          }
          d=d.substring(0, d.lastIndexOf('access_token')-1);
          var e = $("#map-area").find("img").width();
          var c =$("#map-area").find("img").height();

          var f = ($("#map-area").find("img").height() / $("#map-area").find("img").width()) * 100;
          var a = "";
          a = '<div class="litetooltip-hotspot-wrapper" style="max-width: ' + e + 'px">\n';
          a += '<div class="litetooltip-hotspot-container" style="padding-bottom: ' + f + '%">\n';
          a += '<img src="' + $("#map-area").find("img").attr("src") + '" data-width="' + e + '" data-height="' + c + '" />\n';
          $("#map-area").find(".hotspot").each(function () {
              let g = $(this);
              let cssConfig = g.data("hot-cssconfig");
              if (!cssConfig) {
                  cssConfig = JSON.parse(unescape(g.data("cssconfig")));
              }
              var n = ((g.parent().position().left + 6) / e) * 100;
              var o = ((g.parent().position().top + 6) / c) * 100;
              var q = ((g.width() / e) * 100).toString();
              var m = ((g.height() / c) * 100).toString();
              var i = g.data("hotspot-bgcolor");
              var k = "1px solid " + g.data("hotspot-bordercolor");
              var l = g.data("hotspot-borderradius");
              var j = String(g.data("hotspot-blink")) == "true" ? " blink" : "";
              var back,backImg,borderradius;
              if(cssConfig && cssConfig["background"]){
                  back=cssConfig["background"];
              }
              if(cssConfig && cssConfig["background-image"]){
                  backImg=cssConfig["background-image"];
              }
              if(cssConfig && cssConfig["border-radius"]){
                  borderradius=cssConfig["border-radius"];
              }
              var trigger;
              if (g.data("trigger")) {
                  trigger = g.data("trigger");
              } else {
                  trigger = g.data("conf");
              }
              var opac = 1;
              if (cssConfig.type != "button")
              {
                  q += "%";
                  m += "%";
                  opac = 0;
              }
              else
              {
                  q = "30px";
                  m = "30px";
              }

              
              if (trigger == 'hover') {
                  trigger = 'hoverable';
              }
              var h = '<div class="hotspot"'+
                  'style=" top: ' + o + "%; left: " + n + "%; width: " + q + "; height: " + m + "; background: " + back + "; background-color: " + cssConfig["background-color"] + "; background-image: " + backImg + "; border-radius: " + borderradius + "; opacity: " + opac + ";\"" +
                  ' data-location="bottom"' +
                  ' data-opacity="1"' +
                  ' data-backcolor="#ffffff"' +
                  ' data-textcolor="#000000"' +
                  ' data-textalign="center"' +
                  ' data-margin="5"' +
                  ' data-padding="10"' +
                  ' data-width="0"' +
                  ' data-delay="0"' +
                  ' data-trigger="' + trigger + '"' +
                  ' data-issticky="true"' +
                  ' data-hotspot-x="' + n + '"' +
                  ' data-hotspot-y="' + o + '"' +
                  ' data-hotspot-blink="false"' +
                  ' data-hotspot-bgcolor="#cc0000"' +
                  ' data-hotspot-bordercolor="#cc0000"' +
                  ' data-hotspot-borderradius="' + g.data("hotspot-borderradius") + '">' +
                  '\n<div class="data-container">' + g.find(".data-container").html() + "</div>\n</div>\n\n";
              let redirectData:any;
              redirectData = unescape(g.data("isredirect"));
              if(redirectData != "undefined"){
                  redirectData=JSON.parse(redirectData);
              }
              var $tempH = $(h);
              if(redirectData != "undefined" && redirectData && redirectData.isredirect == true)
              {
                  $tempH.attr("data-redirecttype", g.data("redirecttype"));
                  $tempH.attr("data-clickredirect", redirectData.value);                        
              }
              a += $tempH.prop('outerHTML')
          });
          a += "</div>\n";
          a += "</div>";

          return $(a).html();
      }
      $("#map-area").mousedown(function (a) {
          removeToolTips();
      });
      $("#map-area").droppable({
          drop: function (event, ui) {
              var iconSrc = $(ui.draggable).attr('id');
              var type = $(ui.draggable).attr('type');
              var buttonColor = $(ui.draggable).attr('buttonColor');

              var $newPosX = ui.offset.left - $(this).offset().left;
              var $newPosY = ui.offset.top - $(this).offset().top;

              if (iconSrc && iconSrc.lastIndexOf("selector_") < 0) {
                  var g = $.now();
                  var f = "selector_" + g;
                  var d = "hotspot_" + g;
                  var cssConfig = {};
                  if (type === "button") {
                      cssConfig = {
                          "background-image": "url('" + iconSrc + "')",
                          width: "28",
                          height: "30px",
                          "border-radius": "20px",
                          opacity: 1,
                          type: "button",
                          "background-color":buttonColor,
                          id:f
                      }
                  } else if (type == "circle") {
                      cssConfig = {
                          background: "#778899",
                          width: "30px",
                          height: "30px",
                          "border-radius": "100%",
                          opacity: 0.2,
                          type: "circle",
                          id:f
                      }
                  } else if (type == "square") {
                      cssConfig = {
                          background: "#778899",
                          width: "30px",
                          height: "30px",
                          opacity: 0.2,
                          type: "square",
                          id:f
                      };
                  }

                  var b = $('<div class="selector" id="' + f + '"><div data-cssconfig='+escape(JSON.stringify(cssConfig))+' id="' + d + '" class="hotspot ui-widget-content"><div class="data-container" style="display:none"></div></div></div>');

                  b.css({
                      position: "absolute",
                      top: $newPosY,
                      left: $newPosX,
                      padding: "5px"
                  });
                  b.find(".hotspot").css(cssConfig);
                  if (type !== "button") {
                      b.resizable({
                          alsoResize: b.find(".hotspot"),
                          containment: "parent",
                          resize: function () {
                              changeSelection(b);
                          },
                          stop: function () {
                              resetHotSpots();
                          }
                      });
                  }
                  b.draggable({
                      containment: "parent",
                      scroll: false,
                      start: function () {
                          changeSelection(this)
                      },
                      stop: function () {
                          resetHotSpots();
                      }
                  });
                  b.appendTo(this);
                  b.mousedown(function () {
                      changeSelection(this);
                      return false
                  });
                  b.dblclick(function (event) {
                      removeToolTips();
                      setProperties(this,event,true);
                      return false
                  });
                  b.on('doubletap', function (event) {
                      removeToolTips();
                      setProperties(this,event,true);
                      return false
                  })
                  setProperties(this, event,false);
                  setTimeout(function () {

                     removeToolTips();
                     saveHotspot(b.find(".hotspot").attr("id"));

                   }, 500);
              }
          }
      });
      var hotspotIds=[];
      function loadImage(IsFirstTime) {
          var $editorHtml = $("<div></div>").append((self.imgBlock.hotspotEditedHtmlString));
          var hotSpotPointsArr = $editorHtml.find(".selector");
          hotspotIds=[];
          if (IsFirstTime) {
              $("#map-area").html("");
          }
          else {
              $("#map-area").find(".selector").remove();
          }
          var a = $("<div></div>");
          a.appendTo($("#map-area"));
          each(hotSpotPointsArr, function (po) {
              var point = $(po);
              point.draggable({
                  containment: "parent",
                  scroll: false,
                  start: function () {
                      changeSelection(this)
                  },
                  stop: function (event) {
                      resetHotSpots();
                      removeToolTips();

                      setProperties(this, event,false);
                      setTimeout(function () {
                          var previousId = point.find(".hotspot").attr("id");

                          saveHotspot(point.find(".hotspot").attr("id"));
                          $("body").find("#" + previousId).remove();
                      },500);

                  }
              });
              var cssConfig = JSON.parse(unescape(point.find(".hotspot").data("cssconfig")));
              var triger = point.find(".hotspot").data("trigger");
              if (triger == "hover") {
                  triger = "hoverable";
              }
              point.data("hot-cssconfig", cssConfig);
              //If type is button then set css for hotspot icon else bind resizable plugins
              if (cssConfig.type == "button") {
                  point.find(".hotspot").css(cssConfig);
              }
              else {
                  //== This is for removing resizable handles. It will be added dynamically by resizazble plugin ===/
                  point.find(".ui-resizable-handle").remove();
                  point.resizable({
                      alsoResize: point.find(".hotspot"),
                      containment: "parent",
                      resize: function () {
                          changeSelection(point);
                      },
                      stop: function (event) {
                          removeToolTips();
                          resetHotSpots();
                          setProperties(this, event,false);
                          setTimeout(function(){
                              var previousId = point.find(".hotspot").attr("id");
                              saveHotspot(point.find(".hotspot").attr("id"));
                              $("body").find("#" + previousId).remove();
                          },500);
                      }
                  });
              }

              point.appendTo($("#map-area"));
              point.data("trigger", triger);
              point.data("location", "bottom");
              point.data("backcolor", "#ffffff");
              point.data("textcolor", "#000000");

              hotspotIds.push(point.find(".hotspot").attr("id"));

              point.LiteTooltip({
                  title: getDataTitle(point),
                  id: point.find(".hotspot").attr("id"),
                  width: '300px'
              });
              point.mousedown(function () {
                  changeSelection(this);
                  return false
              });
              point.dblclick(function (event) {
                  removeToolTips();
                  setProperties(this, event,true);
                  return false;
              });
          });
          if (IsFirstTime) {
              self.commonHttpService.get({
                  uri: self.imagepath
              }).subscribe((assetAzureUrl: any) => {
                  const azureUrl = assetAzureUrl.replace(/ /g, '%20');
                  var b = $('<img src=' + azureUrl + '></img>');
                  b.css({
                      border: "1px solid #ffffff"
                  });
                  b.appendTo(a);
                  b.on('load', function () {
                      var imgHeight = b[0].naturalHeight;
                      var imgWidth = b[0].naturalWidth;

                      $("#map-area").css({
                          width: imgWidth + 2,
                      });
                      $(this).attr("data-width", imgWidth);
                      $(this).attr("data-height", imgHeight);
                      a.css({
                          position: "relative",
                          width: imgWidth,
                          "max-width": "100%"
                      })
                  })
              })
          }
      }
      loadImage(true);
  
  }

}
